import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { ArrowLeft } from "@bw/icons"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  font-weight: 300;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`
const StyledBreadcrumb = styled(Link)`
  display: none;
  font-size: 14px;
  color: #fff;
  line-height: 24px;
  text-decoration: none;

  /* the second last item is the only one visible on smartphones */
  &:nth-last-child(2) {
    display: flex;
    align-items: center;
    font-weight: 500;
    gap: 10px;

    @media (min-width: ${breakpoints.medium}px) {
      display: inline-block;
      font-weight: 300;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    display: inline-block;

    svg {
      display: none;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    &:nth-child(n + 2) {
      &:before {
        content: ">";
        display: inline-block;
        margin: 0 8px;
      }
    }
  }

  &:last-child {
    font-weight: 500;
    pointer-events: none;
  }
`
const Breadcrumbs = ({ breadcrumbs }) => {
  return (
    <Wrapper>
      {breadcrumbs.map((item, i) => (
        <StyledBreadcrumb key={i} to={item.to}>
          {i === breadcrumbs.length - 2 && <ArrowLeft fillColor="#fff" />}
          {item.title}
        </StyledBreadcrumb>
      ))}
    </Wrapper>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

export { Breadcrumbs }
